import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Flame, LogOut, Zap, Trophy } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { useT } from "../context/LanguageContext";
import LanguageToggle from "./LanguageToggle";

export default function TopBar({ showTrophies = true }) {
  const { user, logout } = useAuth();
  const t = useT();
  const navigate = useNavigate();
  if (!user) return null;
  return (
    <motion.header
      initial={{ y: -30, opacity: 0 }} animate={{ y: 0, opacity: 1 }}
      className="glass sticky top-0 z-40 px-4 py-3 flex items-center justify-between"
      data-testid="top-bar"
    >
      <div className="flex items-center gap-3">
        <LanguageToggle />
        <button onClick={() => navigate("/dashboard")} className="font-heading font-black text-lg tracking-tight bouncy" data-testid="logo-btn">
          <span style={{ color: "var(--cyan)" }}>Aero</span>Learn
        </button>
      </div>
      <div className="flex items-center gap-3 sm:gap-4 font-num">
        <div className="flex items-center gap-1" data-testid="stat-streak">
          <Flame size={18} style={{ color: "#FF7A00" }} />
          <span>{user.streak}</span>
        </div>
        <div className="flex items-center gap-1" data-testid="stat-level">
          <Zap size={18} style={{ color: "var(--cyan)" }} />
          <span>Lv {user.level}</span>
        </div>
        {showTrophies && (
          <button onClick={() => navigate("/badges")} className="bouncy" data-testid="trophies-btn" title={t("Traguardi")}>
            <Trophy size={18} style={{ color: "var(--gold)" }} />
          </button>
        )}
        <button onClick={async () => { await logout(); navigate("/"); }} className="bouncy" data-testid="logout-btn" title={t("Esci")}>
          <LogOut size={18} className="text-white/70" />
        </button>
      </div>
    </motion.header>
  );
}
